interface AnchorLinksMenuProps {
    el: HTMLElement;
}

const AnchorLinksMenu = ({ el }: AnchorLinksMenuProps): () => void => {
    let offsetHeight = 0;
    const elHeight = el.offsetHeight;

    const updateOffsetHeight = (): void => {
        if (window.innerWidth > 1280) {
            const mobileHeader = document.querySelector('.mobile-header') as HTMLElement | null;
            if (mobileHeader) {
                ({ offsetHeight } = mobileHeader);
            }
        } else {
            const anchorContentSectionHeaders = document.querySelectorAll('.anchor-content-section .section-intro');
            anchorContentSectionHeaders.forEach(header => {
                (header as HTMLElement).style.top = `${24 + 84 + offsetHeight}px`;
            });
        }

        el.style.top = `${offsetHeight}px`;
    };

    updateOffsetHeight();

    const links = el.querySelectorAll('.anchor-links-menu a');
    links.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault(); // Ensures scroll behaviour works
            const targetId = link.getAttribute('href')?.substring(1);
            if (targetId) {
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    const y = targetElement.getBoundingClientRect().top + window.scrollY - offsetHeight - elHeight;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }
        });
    });

    const updateActiveLink = (): void => {
        let activeLink: HTMLAnchorElement | null = null;
        const sections: HTMLElement[] = [];

        links.forEach(link => {
            const targetId = link.getAttribute('href')?.substring(1);
            if (targetId) {
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    sections.push(targetElement);
                    const rect = targetElement.getBoundingClientRect();
                    if (rect.top <= offsetHeight + elHeight && rect.bottom >= offsetHeight + elHeight) {
                        activeLink = link as HTMLAnchorElement;
                    }
                }
            }
        });

        // Clear all active states first
        links.forEach(link => {
            link.classList.remove('active');
        });

        // If no section is currently in view, determine which default to use
        if (!activeLink && links.length > 0) {
            if (sections.length > 0) {
                const lastSection = sections[sections.length - 1];
                const lastRect = lastSection.getBoundingClientRect();
                // If we're below the last section, keep the last link active
                if (lastRect.bottom < offsetHeight + elHeight) {
                    activeLink = links[links.length - 1] as HTMLAnchorElement;
                } else {
                    // Otherwise, default to the first link (above all sections)
                    activeLink = links[0] as HTMLAnchorElement;
                }
            } else {
                activeLink = links[0] as HTMLAnchorElement;
            }
        }

        if (activeLink) {
            activeLink.classList.add('active');
        }
    };

    const checkSticky = (): void => {
        const rect = el.getBoundingClientRect();
        const isSticky = rect.top <= 0;

        if (isSticky) {
            el.classList.add('sticky');
        } else {
            el.classList.remove('sticky');
        }
    };

    checkSticky();
    updateActiveLink(); // Set initial active state

    // Add scroll event listener
    window.addEventListener('scroll', checkSticky);
    window.addEventListener('scroll', updateActiveLink);
    window.addEventListener('resize', updateOffsetHeight);

    return () => {
        window.removeEventListener('scroll', checkSticky);
        window.removeEventListener('scroll', updateActiveLink);
        window.removeEventListener('resize', updateOffsetHeight);
    };
};

export default AnchorLinksMenu;
